/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddPayoutRequest,
    EditPayoutRequest,
    IdResponse,
    PatchPayoutRequest,
} from '../models';

export interface IncentivePayoutApiControllerAddIncentivePayoutRequest {
    sellerId: string;
    addPayoutRequest: AddPayoutRequest;
}

export interface IncentivePayoutApiControllerDeleteIncentivePayoutRequest {
    sellerId: string;
    payoutId: string;
}

export interface IncentivePayoutApiControllerEditIncentivePayoutRequest {
    sellerId: string;
    payoutId: string;
    editPayoutRequest: EditPayoutRequest;
}

export interface IncentivePayoutApiControllerPatchIncentivePayoutRequest {
    sellerId: string;
    payoutId: string;
    patchPayoutRequest: PatchPayoutRequest;
}

/**
 * 
 */
export class StoreIncentivePayoutApi extends runtime.BaseAPI {

    /**
     */
    async incentivePayoutApiControllerAddIncentivePayoutRaw(requestParameters: IncentivePayoutApiControllerAddIncentivePayoutRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling incentivePayoutApiControllerAddIncentivePayout.');
        }

        if (requestParameters.addPayoutRequest === null || requestParameters.addPayoutRequest === undefined) {
            throw new runtime.RequiredError('addPayoutRequest','Required parameter requestParameters.addPayoutRequest was null or undefined when calling incentivePayoutApiControllerAddIncentivePayout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/incentive-payouts`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addPayoutRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async incentivePayoutApiControllerAddIncentivePayout(requestParameters: IncentivePayoutApiControllerAddIncentivePayoutRequest): Promise<IdResponse> {
        const response = await this.incentivePayoutApiControllerAddIncentivePayoutRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async incentivePayoutApiControllerDeleteIncentivePayoutRaw(requestParameters: IncentivePayoutApiControllerDeleteIncentivePayoutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling incentivePayoutApiControllerDeleteIncentivePayout.');
        }

        if (requestParameters.payoutId === null || requestParameters.payoutId === undefined) {
            throw new runtime.RequiredError('payoutId','Required parameter requestParameters.payoutId was null or undefined when calling incentivePayoutApiControllerDeleteIncentivePayout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/incentive-payouts/{payoutId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"payoutId"}}`, encodeURIComponent(String(requestParameters.payoutId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async incentivePayoutApiControllerDeleteIncentivePayout(requestParameters: IncentivePayoutApiControllerDeleteIncentivePayoutRequest): Promise<void> {
        await this.incentivePayoutApiControllerDeleteIncentivePayoutRaw(requestParameters);
    }

    /**
     */
    async incentivePayoutApiControllerEditIncentivePayoutRaw(requestParameters: IncentivePayoutApiControllerEditIncentivePayoutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling incentivePayoutApiControllerEditIncentivePayout.');
        }

        if (requestParameters.payoutId === null || requestParameters.payoutId === undefined) {
            throw new runtime.RequiredError('payoutId','Required parameter requestParameters.payoutId was null or undefined when calling incentivePayoutApiControllerEditIncentivePayout.');
        }

        if (requestParameters.editPayoutRequest === null || requestParameters.editPayoutRequest === undefined) {
            throw new runtime.RequiredError('editPayoutRequest','Required parameter requestParameters.editPayoutRequest was null or undefined when calling incentivePayoutApiControllerEditIncentivePayout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/incentive-payouts/{payoutId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"payoutId"}}`, encodeURIComponent(String(requestParameters.payoutId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editPayoutRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async incentivePayoutApiControllerEditIncentivePayout(requestParameters: IncentivePayoutApiControllerEditIncentivePayoutRequest): Promise<void> {
        await this.incentivePayoutApiControllerEditIncentivePayoutRaw(requestParameters);
    }

    /**
     */
    async incentivePayoutApiControllerPatchIncentivePayoutRaw(requestParameters: IncentivePayoutApiControllerPatchIncentivePayoutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling incentivePayoutApiControllerPatchIncentivePayout.');
        }

        if (requestParameters.payoutId === null || requestParameters.payoutId === undefined) {
            throw new runtime.RequiredError('payoutId','Required parameter requestParameters.payoutId was null or undefined when calling incentivePayoutApiControllerPatchIncentivePayout.');
        }

        if (requestParameters.patchPayoutRequest === null || requestParameters.patchPayoutRequest === undefined) {
            throw new runtime.RequiredError('patchPayoutRequest','Required parameter requestParameters.patchPayoutRequest was null or undefined when calling incentivePayoutApiControllerPatchIncentivePayout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/incentive-payouts/{payoutId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"payoutId"}}`, encodeURIComponent(String(requestParameters.payoutId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchPayoutRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async incentivePayoutApiControllerPatchIncentivePayout(requestParameters: IncentivePayoutApiControllerPatchIncentivePayoutRequest): Promise<void> {
        await this.incentivePayoutApiControllerPatchIncentivePayoutRaw(requestParameters);
    }

}
